import React from "react";
import { classNames } from "../../common_util";

import { Deal } from "../types/storefront";
import { ReactComponent as TagsFavourite } from "images/icons/tags-favorite.svg?react";

const activeDealIconClasses = classNames({
  "icon": true,
  "custom-icon": true,
  "is-medium": true,
});

export const ActiveDealCard = ({
  deal
} : {
  deal: Deal;
}) => {
  const termsSummary = deal.termsAndConditions != null &&
    <>
      {' '}
      <a className="has-underline" data-action="click->orders#toggleDealTermsAndConditions">
        <span>Terms and Conditions.</span>
      </a>
    </>

  const termsBody = deal.termsAndConditions != null &&
    <p className="is-completely-hidden" data-orders-target="dealTermsAndConditions"
       data-testid="terms-and-conditions">
      {deal.termsAndConditions}
    </p>;

  return (
    <div className="callout has-coloured-icon" data-controller="orders">
      <span className={activeDealIconClasses}>
        <TagsFavourite/>
      </span>

      <div>
        <div className="title">{deal.title}</div>
        <p>
          {deal.description}

          {termsSummary}
        </p>

        {termsBody}
      </div>
    </div>
  );
}
